exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_settings_1eNtVTtvB7mvmzzURggvoV {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_17e7QNQSGH8XSV1of77PbT {\n  width: 100%;\n  margin-bottom: 10px;\n  float: left;\n  clear: both;\n}\n\n.IA_pivotContent_2-N3yTa1NVzmCD3bz3MoiA {\n  width: 100%;\n  float: left;\n  overflow: hidden;\n}\n\n.IA_settings_1eNtVTtvB7mvmzzURggvoV h3 {\n  font-size: 18px;\n  padding-top: 20px;\n  float: left;\n}", ""]);

// Exports
exports.locals = {
	"IA_settings": "IA_settings_1eNtVTtvB7mvmzzURggvoV",
	"IA_filters": "IA_filters_17e7QNQSGH8XSV1of77PbT",
	"IA_pivotContent": "IA_pivotContent_2-N3yTa1NVzmCD3bz3MoiA"
};